import axios from 'axios';

const loadAbort = () => {
  return new AbortController();
};

export const projectListByPositionEndpoint = (token: string) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'get',
        url: `${urlService}/pre-sales/v1/admin/projects/by-position`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};

export {
  getAmenitiesEndpoint,
  getProjectCurrenciesEndpoint,
  getProjectTagsEndpoint,
} from './../../../services/publicService';

export const getAmenityDetailsEndpoint = (projectId: string, amenityId: string, token: string) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'get',
        url: `${urlService}/pre-sales/v1/admin/projects/${projectId}/amenities/${amenityId}/details`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};

export const uploadAmenityImageEndpoint = (
  projectId: string,
  amenityId: string,
  formData: FormData,
  token: string,
) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'put',
        url: `${urlService}/pre-sales/v1/admin/projects/${projectId}/amenities/${amenityId}/upload-image`,
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`,
        },
        data: formData,
      }),
    controller,
  };
};
